import { FC, PropsWithChildren, useCallback } from "react";

import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import styled from "styled-components";

import { useNavigateSearch } from "@/premium/hooks";

import { Card } from "../../../themedComponents/Card";

const ThemedPlanTitle = styled.div`
  font-family: ${(props) => props.theme.font || "Source Sans 3"};
  font-size: 32px;
  font-weight: 400;
`;

const PlanCardContainer = styled.div`
  color: #97989e;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export interface PlanCardProps {
  id: number;
}

export const PlanCard: FC<PropsWithChildren<PlanCardProps>> = (props) => {
  const { children, id } = props;
  const navigateSearch = useNavigateSearch();

  const navigateToPlan = useCallback(() => {
    navigateSearch("/plan", {
      enrollmentPlan: id,
    });
  }, [id, navigateSearch]);

  return (
    <Card fullHeight={true}>
      <PlanCardContainer onClick={() => navigateToPlan()}>
        <Shelf>
          <ThemedPlanTitle>{children}</ThemedPlanTitle>
          <Shelf.Spacer />
          <Icon name="chevron-right" color="lightgrey" />
        </Shelf>
      </PlanCardContainer>
    </Card>
  );
};
